import {
  initialState,
  Actions,
  State,
  GET_ONE_ACTIVITY,
  GET_ONE_ACTIVITY_SUCCESS,
  GET_ONE_ACTIVITY_ERROR,
  RESET_GET_ONE_ACTIVITY,
} from "../../types/activity/getOne";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_ACTIVITY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ONE_ACTIVITY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ONE_ACTIVITY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_ONE_ACTIVITY:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
